"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isClassFactory = exports.addFluentResolvingFactory = exports.addFactory = void 0;
function addFactory(adder, origin) {
    return (method) => {
        const body = origin[method];
        return adder(method, body);
    };
}
exports.addFactory = addFactory;
function addFluentResolvingFactory(FluentClass) {
    return (method, body) => {
        if (FluentClass.prototype.hasOwnProperty(method)) {
            throw new TypeError(`Prototype already has a method called ${method}`);
        }
        FluentClass.prototype[method] = body;
    };
}
exports.addFluentResolvingFactory = addFluentResolvingFactory;
function isClassFactory(Class) {
    const methodName = `is${Class.name}`;
    const result = {
        [methodName](value) {
            return value instanceof Class;
        },
    };
    return result[methodName];
}
exports.isClassFactory = isClassFactory;
